<div class="otp-form" id="cmvloadingmodal">
	<form [formGroup]="acceptTermsForm" class="otp-form__checks">
		<div class="form-check otp-form__check-item">
			<input
				type="checkbox"
				class="form-check-input"
				id="acceptTerms"
				name="acceptTerms"
				formControlName="acceptTerms"
				#acceptTermsInput />
			<label class="form-check-label" for="acceptTerms">
				Confirmo que este código se utilizará para la autorización por medios
				electrónicos de la consulta de mi
				<button
					class="otp-form__terms-link"
					type="button"
					(click)="showTerms()">
					Buró de Crédito
				</button>
			</label>
		</div>
		<div
			class="otp-form__terms-error"
			*ngIf="acceptTermsField.errors?.['required'] && acceptTermsField.dirty">
			Este campo es obligatorio
		</div>

		<div class="form-check otp-form__check-item">
			<input
				type="checkbox"
				class="form-check-input"
				id="acceptGeographicalLocation"
				name="acceptGeographicalLocation"
				formControlName="acceptGeographicalLocation" />
			<label class="form-check-label" for="acceptGeographicalLocation">
				Acepto el uso de mi ubicación geográfica y validación de datos de
				credencial para votar y comparación de biometría facial ante el INE
			</label>
		</div>
		<div
			class="otp-form__terms-error"
			*ngIf="acceptGeographicalLocationField.errors?.['required'] && acceptGeographicalLocationField.dirty">
			Este campo es obligatorio
		</div>
	</form>

	<cmv-enter-code
		#enterCodeRef
		*ngIf="applicantPhoneAndIsApplicantAMember$ | async as dataForEnterCode"
		[phoneNumber]="dataForEnterCode.applicantPhone"
		[isMember]="dataForEnterCode.isApplicantAMember"
		[memberNumber]="dataForEnterCode.applicantId"
		[skipInternalValidation]="true"
		(generateOtpSuccess)="onShowGeneratedOtpMessage($event)"
		(successEnterCode)="onSuccess($event)"
		(errorEnterCode)="onShowEnterCodeError($event)">
		<button after-resend class="otp-form__submit-btn" type="button" (click)="onContinuar()">
			Enviar mis datos
		</button>
	</cmv-enter-code>
</div>
